import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { RequestAccessModal } from "@/components/auth/RequestAccessModal";
import { apiClient } from "@/services/api";

export function RequestAccessBanner() {
  const [modalOpen, setModalOpen] = useState(false);
  const [justSubmitted, setJustSubmitted] = useState(false);

  const { data: accessRequest } = useQuery<{ status: string } | null>({
    queryKey: ["access-request-me"],
    queryFn: () => apiClient.get("/api/v1/access-requests/me"),
    staleTime: 60_000,
  });

  const hasRequested = justSubmitted || accessRequest?.status != null;

  return (
    <div className="mx-3 rounded-lg border bg-card p-3 text-card-foreground">
      <div className="flex items-center gap-2 mb-1.5">
        <ShieldCheck className="h-4 w-4 text-primary shrink-0" />
        <span className="text-sm font-medium leading-tight">Real-time AI Agent Monitoring</span>
      </div>
      <p className="text-xs text-muted-foreground mb-2.5">
        Auto-detect prompt injection, jailbreaks, and data leakage as they happen.
      </p>
      <Button size="sm" className="w-full" disabled={hasRequested} onClick={() => setModalOpen(true)}>
        {hasRequested ? "Access Requested" : "Request Access"}
      </Button>
      {!hasRequested && (
        <RequestAccessModal
          open={modalOpen}
          onOpenChange={setModalOpen}
          onSuccess={() => setJustSubmitted(true)}
        />
      )}
    </div>
  );
}
